<script>
export default {
  props: {
    entries: {
      type: [Array, Object],
      default: () => [],
    },
  },
  computed: {
    normalizedEntries() {
      const entries = Array.isArray(this.entries) ? this.entries : [this.entries];

      return entries.filter(
        (entry) => entry && typeof entry === "object" && Object.keys(entry).length
      );
    },
    nonce() {
      if (typeof window === "undefined") {
        return null;
      }

      return window.nonce || null;
    },
  },
  methods: {
    serialize(entry) {
      return JSON.stringify(entry)
        .replace(/</g, "\\u003c")
        .replace(/>/g, "\\u003e")
        .replace(/&/g, "\\u0026")
        .replace(/\u2028/g, "\\u2028")
        .replace(/\u2029/g, "\\u2029");
    },
    getEntryKey(entry, index) {
      return entry["@id"] || entry["@type"] || `schema-${index}`;
    },
  },
  render(h) {
    if (!this.normalizedEntries.length) {
      return null;
    }

    const children = this.normalizedEntries.map((entry, index) => {
      const key = this.getEntryKey(entry, index);
      const attrs = {
        type: "application/ld+json",
        "head-key": `jsonld-${key}`,
      };

      if (this.nonce) {
        attrs.nonce = this.nonce;
      }

      return h("script", {
        key,
        attrs,
      }, [this.serialize(entry)]);
    });

    return h("inertia-head", {
      scopedSlots: {
        default: () => children,
      },
    });
  },
};
</script>
